import Button from 'base-components/Button'
import { useScene } from 'providers/SceneProvider'
import { FC } from 'react'

interface Props {}

const NavigateButton: FC<Props> = () => {
  const { toggleShowTable, showTable } = useScene()

  return (
    <div className='flex absolute z-50 top-0 w-full m-4 select-none justify-center pb-14 pointer-events-none'>
      <div className='flex flex-row pointer-events-auto'>
        <div className='flex flex-col justify-center items-start'>
          <Button
            // className='bg-white p-2 px-4 rounded-xl border-[1px] shadow-lg border-gray-800 text-gray-800 uppercase text-sm font-semibold'
            onClick={toggleShowTable}
          >
            {showTable ? 'Visa karta' : 'Visa tabell'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NavigateButton
